import { Component, ChangeDetectionStrategy, input } from '@angular/core';

/**
 * EmptyState — the calm "nothing here yet" surface. Neutral (muted icon, never
 * red) so it doesn't read like an error. Optional `[empty-action]` CTA slot.
 * Covers operator's "No event assigned", calendar's "No events", etc.
 */
@Component({
  selector: 'bodyanalytics-empty-state',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
})
export class EmptyStateComponent {
  /** Boxicons glyph class, e.g. `bx-calendar-x`. */
  icon = input('bx-inbox');
  heading = input('Nothing here yet');
  message = input<string>();
}
